import {useUser} from "../../../context/UserContext";
import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import EmptyLine from "../EmptyLine";
import CheckCSName from "../CheckCSName";
import ResultTable from "../../../components/table/ResultTable";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultRow from "../../../components/table/ResultRow";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultBody from "../../../components/table/ResultBody";
import HecRasHelper from "../../../helpers/HecRasHelper";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import ResultView from "../../../components/ResultView";

export function G1({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {

    const libWsel = (wsel, libWsel, tnm) => {
        if(!wsel || !libWsel)
            return <div style={{color: 'red'}}>-</div>

        try {
            if(Math.abs(parseFloat(wsel)-parseFloat(libWsel)) === 0) {
                return <div>{parseFloat(libWsel)?.toFixed(2)}</div>
            }
            else if(Math.abs(parseFloat(wsel)-parseFloat(libWsel)) <= settings?.defaults?.tnm_tolerance) {
                return <div style={{color: 'orange'}}>{parseFloat(libWsel)?.toFixed(2)}</div>
            }
            else if(tnm) {
                return <div style={{color: 'red'}}>{parseFloat(libWsel)?.toFixed(2)}</div>
            }
        }
        catch (exp) {
            console.log(exp)
            return <div style={{color: 'red'}}>-</div>
        }
    }

    switch (row.error_id) {
        case MessageCodes.Internal.LB01.error_id: {
            return (
                <>
                    {
                        row?.data?.map(r => {
                            if(!r?.river && !r?.reach) {
                                return (
                                    <ResultText>
                                        There are {row?.cs_count || 0} cross sections in the library model. The gage is located at RS  <CheckCSName csName={r?.cross_section} />.
                                    </ResultText>
                                )
                            }


                            return (
                                <ResultText>
                                    There are {row?.cs_count || 0} cross sections on {r?.river}/{r?.reach} of the library model. The gage is located at RS <CheckCSName csName={r?.cross_section} /> on {r?.gage_river}/{r?.gage_reach}.
                                </ResultText>
                            )
                        })
                    }
                </>
            )
        }
        case MessageCodes.Internal.LB02.error_id: {
            return (
                <>
                    {
                        row?.data?.map(r => {
                            const tnm = r?.table?.filter(x => !x[2])?.length
                            return (
                                (
                                    <>
                                        {
                                            tnm > 0 && (
                                                <ResultText>
                                                    There are {r?.table?.length} profiles in the library model and the target is not met for the following {tnm} profiles:
                                                </ResultText>
                                            )
                                        }
                                        {
                                            tnm === 0 && (
                                                <ResultText>
                                                    There are {r?.table?.length} profiles in the library model and all the targets are met.
                                                </ResultText>
                                            )
                                        }
                                        <EmptyLine />
                                        <ResultText>
                                            {
                                                r?.table?.filter(x => !x[2])?.map(x => x[0])?.join(', ')
                                            }
                                        </ResultText>
                                    </>
                                )
                            )
                        })
                    }
                    {
                        row?.data?.map(r => (
                            <>
                                <ResultTable>
                                    <ResultHeader>
                                        <ResultRow>
                                            <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(10)}}>Profile</ResultHeaderCell>
                                            <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>WSEL</ResultHeaderCell>
                                        </ResultRow>
                                    </ResultHeader>
                                    <ResultBody>
                                        {
                                            r?.table?.map(x => {

                                                return (
                                                    <ResultRow>
                                                        <ResultBodyCell style={{textAlign: 'left', color: x[2] ? '' : 'red'}}>
                                                            {x[0]}
                                                        </ResultBodyCell>
                                                        <ResultBodyCell style={{textAlign: 'right'}}>
                                                            {libWsel(x[0], x[1], !x[2])}
                                                        </ResultBodyCell>
                                                    </ResultRow>
                                                )
                                            })
                                        }
                                    </ResultBody>
                                </ResultTable>
                            </>
                        ))
                    }
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}